<template>
    <div class="p-4 md:max-w-4xl w-full justify-center m-auto">
      <!-- Tabs Section -->
      <div class="flex space-x-4 mb-6 overflow-scroll">
        <button 
          v-for="(tab, index) in tabs" 
          :key="index" 
          @click="currentTab = tab"
          :class="[
            'px-4 py-2 rounded-lg font-semibold',
            currentTab === tab ? 'bg-yellow-500 text-white' : 'bg-gray-200 text-gray-800'
          ]"
        >
          {{ tab }}
        </button>
      </div>
  
      <!-- Accordion Section (Content Changes Based on Selected Tab) -->
      <div class="space-y-4 text-left">
       
        <div v-if="currentTab === 'Business Intelligence'">
  <div v-for="(item, index) in businessIntelligenceContent" :key="index">
    <button 
      @click="toggleAccordion(index)"
      class="w-full text-left my-2 px-4 py-2 bg-blue-100 text-blue-800 rounded-lg font-semibold flex justify-between items-center"
    >
      {{ item.title }}
      <span>{{ isOpen(index) ? '▲' : '▼' }}</span>
    </button>
    <div v-if="isOpen(index)" class="p-4 bg-blue-50 rounded-lg mt-2">
      <div v-if="item.content.courseOverview" class="py-4">
        <h4 class="font-bold">Course Overview:</h4>
        <p v-for="(overview, idx) in item.content.courseOverview" :key="idx">{{ overview }}</p>
      </div>
      <h4 class="font-bold">Course Content:</h4>
      <ul class="list-disc list-inside mb-4">
        <li v-for="(content, idx) in item.content.courseContent" :key="idx">{{ content }}</li>
      </ul>
      <h4 class="font-bold">Advantages:</h4>
      <ul class="list-disc list-inside mb-4">
        <li v-for="(advantage, idx) in item.content.advantages" :key="idx">{{ advantage }}</li>
      </ul>
      <h4 class="font-bold" >Career Opportunities:</h4>
      <ul class="list-disc list-inside pb-4 ">
        <li v-for="(career, idx) in item.content.careerOpportunities" :key="idx">{{ career }}</li>
      </ul>
      <h4  v-if="item.content.advantagesofBICertification" class="font-bold">Advantages of BI Certification:</h4>
      <ul class="list-disc list-inside">
        <li v-for="(advantagesofBI, idx) in item.content.advantagesofBICertification" :key="idx">{{ advantagesofBI }}</li>
      </ul>
      
      <!-- Only display the Course Overview if it exists -->

      
    </div>
  </div>
</div>
        <div v-if="currentTab === 'Digital Business'">
          <div v-for="(item, index) in digitalbusinessContent" :key="index">
            <button 
              @click="toggleAccordion(index)"
              class="w-full text-left my-2 px-4 py-2 bg-blue-100 text-blue-800 rounded-lg font-semibold flex justify-between items-center"
            >
              {{ item.title }}
              <span>{{ isOpen(index) ? '▲' : '▼' }}</span>
            </button>
      
            <div v-if="isOpen(index)" class="p-4 bg-blue-50 rounded-lg mt-2">
              <div v-if="item.content.courseOverview" class="py-4">
        <h4 class="font-bold">Overview:</h4>
        <p v-for="(overview, idx) in item.content.courseOverview" :key="idx">{{ overview }}</p>
      </div>
              <h4 class="font-bold">Course Content:</h4>
              <ul class="list-disc list-inside mb-4">
                <li v-for="(content, idx) in item.content.courseContent" :key="idx">{{ content }}</li>
              </ul>
              <h4 class="font-bold">Advantages:</h4>
              <ul class="list-disc list-inside mb-4">
                <li v-for="(advantage, idx) in item.content.advantages" :key="idx">{{ advantage }}</li>
              </ul>
              <h4 class="font-bold">Career Opportunities:</h4>
              <ul class="list-disc list-inside">
                <li v-for="(career, idx) in item.content.careerOpportunities" :key="idx">{{ career }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="currentTab === 'Leadership'">
          <div v-for="(item, index) in leadershipContent" :key="index">
            <button 
              @click="toggleAccordion(index)"
              class="w-full text-left my-2 px-4 py-2 bg-blue-100 text-blue-800 rounded-lg font-semibold flex justify-between items-center"
            >
              {{ item.title }}
              <span>{{ isOpen(index) ? '▲' : '▼' }}</span>
            </button>
            
            <div v-if="isOpen(index)" class="p-4 bg-blue-50 rounded-lg mt-2">
              <div v-if="item.content.courseOverview" class="py-4">
        <h4 class="font-bold">Course Overview:</h4>
        <p v-for="(overview, idx) in item.content.courseOverview" :key="idx">{{ overview }}</p>
      </div>
              <h4 class="font-bold">Course Content:</h4>
              <ul class="list-disc list-inside mb-4">
                <li v-for="(content, idx) in item.content.courseContent" :key="idx">{{ content }}</li>
              </ul>
              <h4 class="font-bold">Advantages:</h4>
              <ul class="list-disc list-inside mb-4">
                <li v-for="(advantage, idx) in item.content.advantages" :key="idx">{{ advantage }}</li>
              </ul>
              <h4 class="font-bold">Career Opportunities:</h4>
              <ul class="list-disc list-inside">
                <li v-for="(career, idx) in item.content.careerOpportunities" :key="idx">{{ career }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="currentTab === 'Fintech'">
          <div v-for="(item, index) in fintechContent" :key="index">
            <button 
              @click="toggleAccordion(index)"
              class="w-full text-left my-2 px-4 py-2 bg-blue-100 text-blue-800 rounded-lg font-semibold flex justify-between items-center"
            >
              {{ item.title }}
              <span>{{ isOpen(index) ? '▲' : '▼' }}</span>
            </button>

            <div v-if="isOpen(index)" class="p-4 bg-blue-50 rounded-lg mt-2">
              <div v-if="item.content.courseOverview" class="py-4">
        <h4 class="font-bold">Course Overview:</h4>
        <p v-for="(overview, idx) in item.content.courseOverview" :key="idx">{{ overview }}</p>
      </div>
              <h4 class="font-bold">Course Content:</h4>
              <ul class="list-disc list-inside mb-4">
                <li v-for="(content, idx) in item.content.courseContent" :key="idx">{{ content }}</li>
              </ul>
              <h4 class="font-bold">Advantages:</h4>
              <ul class="list-disc list-inside mb-4">
                <li v-for="(advantage, idx) in item.content.advantages" :key="idx">{{ advantage }}</li>
              </ul>
              <h4 class="font-bold">Career Opportunities:</h4>
              <ul class="list-disc list-inside">
                <li v-for="(career, idx) in item.content.careerOpportunities" :key="idx">{{ career }}</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- You can add similar sections for other tabs (Digital Business, Leadership, Fintech) -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CertificateView',
    data() {
      return {
        tabs: ['Business Intelligence', 'Digital Business', 'Leadership', 'Fintech'],
        currentTab: 'Business Intelligence', // Default selected tab
        openAccordionIndex: null,
        businessIntelligenceContent: [ 
          {
            title: "Data Visualization and Reporting with Power BI or Tableau (12 hrs)",
            content: {
              courseContent: [
                "Introduction to BI tools and dashboards",
                "Building interactive reports and dashboards",
                "Data analysis using Power BI/Tableau",
                "Integrating data sources (Excel, SQL, etc.)"
          
              ],
              advantages: [
              "Helps students master industry-standard tools for presenting data in an actionable way.",
              "Improves decision-making skills by teaching how to translate data insights into business strategies."
              ],
              careerOpportunities: [
              "Business Intelligence Analyst",
              "Data Analyst",
              "BI Consultant",
              "Reporting Analyst"
              ]
            }
          },
          {
            title: "Predictive Analytics and Data Mining (12 hrs)",
            content: {
              courseContent: [ 

              "Foundations of predictive analytics",
                "Machine learning algorithms for forecasting (linear regression, decision trees, etc.)",
                "Using data mining tools (R, Python, or SAS)",
                "Real-world applications in business decision-making"
              ],
              advantages: [
              "Equips learners with essential skills to forecast trends and understand customer behavior",
                "Prepares students for roles in data-driven decision environments."
          
              ],
     
              advantagesofBICertification: [
              "Enhanced Data Literacy: Learners gain a deep understanding of data interpretation, making them valuable assets in decision-making roles.",
                "Industry-Relevant Skills: Proficiency in tools and technologies like Power BI, Tableau, R, and Python enhances employability.",
                "Cross-Disciplinary Application: BI is used in various industries, from finance to healthcare, providing versatile career paths."
              
              ],
              careerOpportunities: [
              "BI Analyst/Consultant: Analyze business data and provide actionable insights.",
                "Data Analyst: Work with large datasets to uncover trends and aid business strategy.",
                "Analytics Manager: Oversee teams using data to guide company strategy and performance.",
                "Business Systems Analyst: Improve business processes by implementing BI solutions.",
                "Data Scientist: Use statistical methods to interpret data and predict trends."
              ],
            }
          },
          {
            title: "Data-Driven Decision Making and Business Intelligence (12 hrs)",
            content: {
              courseOverview: [
              "This course focuses on the practical application of Business Intelligence in driving data- driven decisions within an organization. It aims to teach students how to interpret data, derive actionable insights, and align business strategies with data analysis",
              
              ],
              courseContent: [
              "Introduction to Data-Driven Decision Making",
                "Data Analytics and Insights Generation",
                "Decision-Making Frameworks",
                "Data Visualization for Decision Making"
              ],
              advantages: [
              "With businesses increasingly relying on data-driven decisions, professionals with Business Intelligence skills are in high demand across multiple industries, including finance, healthcare, retail, and technology.",
                "Understanding how to use data for strategic decision-making improves the ability to contribute to high-level business strategies, making you an asset in management and leadership roles"
           
              ],
              careerOpportunities: [
              "Business Intelligence Analyst",
                "Data Analyst",
                "Business Consultant",
                "Operations Analyst",
                "Product Manager"
              ]
            }
          }
        ],

        digitalbusinessContent: [ 
          {
            title: "Digital Marketing and Strategy  (12hrs)",
            content: {
              courseOverview: [
              "This course would focus on the digital tools and strategies used in modern marketing. Key topics could include social media marketing, SEO, content marketing, email marketing, and analytics."
              ],
              courseContent: [
                "Introduction to Digital Marketing Strategies",
                "Social Media Strategy and Analytics",
                "Digital Branding and Customer Experience",
                "Digital Strategy and Performance Optimization"
              ],
              advantages: [
                "Equips learners with skills to craft digital marketing strategies, optimize digital channels, and understand customer behavior through data.",
               "Enhances adaptability to the rapidly evolving digital marketplace."
              ],
              careerOpportunities: [
                "Digital Marketing Manager",
                "SEO/SEM Specialist",
                "Social Media Strategist",
                "E-commerce Specialist"
      
              ]
            }
          },
          {
            title: "E-commerce and Digital Platforms  (12 hrs)",
            content: {
              courseOverview: [
                "This course would focus on the growing field of e-commerce, with a deep dive into digital platforms, online retail, and omni channel strategies. It could cover online business models, platform economics, payment systems, and consumer data usage."
              ],
              courseContent: [ 

                "Introduction to E-commerce Ecosystem",
                "Platform Business Models",
                "Digital Payment Systems",
                "Technology Infrastructure for E-commerce"
               
              ],
              advantages: [
                "Provides a comprehensive understanding of e-commerce operations, platform integration, and consumer experience management.",
                "Learners will gain insights into managing digital business models and optimizing digital platforms for revenue growth."
              ],
              careerOpportunities: [
             "E-commerce Manager",
             "Product Manager (Digital Platforms)",
             "Digital Transformation Consultant",
             "Platform Strategist"
              ]
            }
          },
          {
            title: "Digital Operations and Supply Chain Management  (12 hrs)",
            content: {
              courseOverview: [
                "This course focuses on how digital technologies are transforming operations and supply chain management. Students will learn how to leverage these technologies to optimize business operations, enhance agility, and respond to evolving customer needs in the digital economy."
              ],
              courseContent: [
                "Introduction to Digital Operations Management",
                "The Role of Technology in Operations",
                "Digital Transformation in Supply Chain Management",
                "Supply Chain Analytics and Optimization"
              ],
              advantages: [
          "High Demand for Digital Skills: Businesses are increasingly adopting digital solutions in supply chain and operations, creating high demand for professionals with expertise in digital technologies like IoT, AI, and automation.",
          "Global Career Opportunities: The digital transformation of supply chains is a global trend, offering career prospects in multinational companies and industries worldwide"
              ],
              careerOpportunities: [
              "Supply Chain Analyst",
             "Operations Manager",
             "Logistics Manager",
             "Digital Transformation Manager (Supply Chain/Operations)",
             "Procurement Specialist"
              ]
            }
          }
        ],
        leadershipContent: [ 
          {
            title: "Strategic Leadership and Innovation   (12hrs)",
            content: {
              courseOverview: [
                "This course focuses on developing leadership skills required for steering organizations through complex changes. It covers strategic decision-making, driving innovation, managing teams, and implementing business strategies in dynamic markets."

            ],
              courseContent: [
             "Foundations of Strategic Leadership",
             "Strategic Innovation Management",
             "Strategic Decision-Making and Problem-Solving",
             "Leading Innovation for Competitive Advantage"
              ],
              advantages: [
                "Holistic View of Leadership: It provides a comprehensive understanding of leading at a strategic level, with a focus on innovation and long-term vision.",
                "Innovation-Driven: Learners gain skills in fostering creativity and leading innovative teams, crucial in today’s competitive markets.",
                "Applicable Across Industries: The skills learned are transferable to various industries, making it versatile for learners."
              ],
              careerOpportunities: [
               "Chief Innovation Officer: Leading innovation initiatives within organizations.",
               "Corporate Strategy Manager: Steering the company’s strategic direction with innovative solutions.",
               "Management Consultant: Providing leadership and strategic insights to businesses."
        
              ]
            }
          },
          {
            title: "Transformational Leadership  (12hrs)",
            content: {
              courseOverview: [
                "This course delves into transformational leadership approaches, focusing on emotional intelligence, change management, motivating teams, and fostering a positive corporate culture. It emphasizes leading with vision and aligning organizational goals with employee engagement."
            ],
              courseContent: [ 

              "Foundations of Transformational Leadership",
               "Leading Organizational Change",
               "Emotional Intelligence and Transformational Leadership",
               "Innovation and Long-Term Impact"
              ],
              advantages: [
             
               "Focus on People: Develops strong interpersonal skills and emotional intelligence, which are critical for team motivation and change management.",
               "Effective Change Leadership: Equips learners to lead organizations through change with confidence and empathy.",
               "Leadership in Challenging Times: Prepares leaders for managing during crises or organizational transitions."
              ],
              careerOpportunities: [
              "Organizational Development Manager: Overseeing programs that enhance corporate culture and employee performance.",
               "Executive Leadership Roles: Becoming a leader who drives meaningful change in organizations.",
               "HR Leadership Roles: Managing leadership development and talent strategies."
              ]
            }
          },
          {
            title: "Digital Leadership   (12hrs)",
            content: {
              courseOverview: [
                "This course focuses on the essential skills and strategies needed to lead organizations through the complexities of digital transformation. Students will learn how to become visionary digital leaders capable of driving innovation, fostering a digital-first culture, and navigating the challenges of disruptive technologies."
            ],
              courseContent: [
              "Introduction to Digital Leadership",
               "The Digital Business Environment",
               "Visionary Leadership in a Digital World",
               "Building a Digital-First Culture"
              ],
              advantages: [
            
               "Gain a strong understanding of how to lead in the digital era, focusing on strategic leadership skills such as managing digital transformations, fostering innovation, and aligning teams with digital goals.",
               "As businesses undergo rapid digital transformations, leaders with digital expertise are in high demand. This course will equip you with the tools to lead successfully in a tech-driven world."
              ],
              careerOpportunities: [
              "Digital Transformation Manager",
               "Digital Product Manager",
               "Strategy Consultant",
               "Digital Operations Manager",
               "Agile Transformation Leader"

              ]
            }
          }
        ],
        fintechContent: [ 
          {
            title: "Blockchain and Cryptocurrencies  (12hrs)",
            content: {
              courseOverview: [
                "This course explores the fundamentals of blockchain technology and its applications in cryptocurrencies. Topics include the mechanics of blockchain, smart contracts, and the implications for financial services."
            ],
              courseContent: [
              "Introduction to Blockchain",
               "Cryptocurrencies",
               "Smart Contracts",
               "Regulatory and Security Issues"
              ],
          
              careerOpportunities: [
              "Blockchain Developer: Design and develop blockchain-based applications and smart contracts.",
               "Cryptocurrency Analyst: Analyze cryptocurrency markets, trends, and investment opportunities for individuals or organizations.",
               "Compliance Officer: Ensure that blockchain and cryptocurrency operations adhere to regulatory standards and policies.",
               "Smart Contract Developer: Focus on creating and auditing smart contracts for security and efficiency.",
               "Advise companies on integrating blockchain solutions into their existing business models."
              ]
            }
          },
          {
            title: "Predictive Analytics and Data Mining (12 hrs)",
            content: {
              courseOverview: [
                "This course covers the various digital payment platforms, technologies, and regulatory issues. It delves into mobile payments, e-wallets, and the future of cashless transactions."
            ],
              courseContent: [ 

              "Introduction to Payment Systems",
               "Mobile Payments",
               "E-Wallets and Digital Banking",
               "Security and Fraud Prevention"
              ],
              careerOpportunities: [
              "Payment Systems Analyst: Evaluate and improve digital payment processes, focusing on efficiency and user experience.",
               "Product Manager: Oversee the development and launch of digital payment products and services.",
               "Risk and Compliance Manager: Assess risks associated with digital payment systems and ensure compliance with regulations.",
              "E-commerce Manager: Manage online payment strategies for businesses, optimizing checkout processes and user experience.",
               "Digital Marketing Specialist: Focus on marketing digital payment solutions and understanding consumer behavior related to payment methods."
              ],
           
            }
          },
          {
            title: "Financial Data Analytics and AI in Fintech  (12hrs)",
            content: {
              courseOverview: [
                "This course explores the intersection of financial technology, data analytics, and artificial intelligence (AI). Students will learn how AI and data analytics are transforming the financial industry by enabling better decision-making, optimizing operations, and improving customer experiences. "
            ],
              courseContent: [
              "Introduction to Financial Data Analytics",
               "Fundamentals of Artificial Intelligence and Machine Learning in Finance",
               "Applications of AI and Data Analytics in Credit Scoring",
               "Fraud Detection and Risk Management"
              ],
              advantages: [
               "Expertise in Emerging Technologies: Gain in-depth knowledge of how AI and machine learning are applied in financial services, giving you a competitive edge in a rapidly evolving industry.",
               "Enhanced Data-Driven Decision Making: Learn how to leverage data and AI to make informed financial decisions, optimize business operations, and drive innovation in the Fintech industry."
              ],
              careerOpportunities: [
              "Financial Analyst ",
               "Risk Analyst",
               "Fraud Detection Specialist",
               "Fintech Consultant",
               "Product Manager (Fintech Solutions)"
              ]
            }
          }
        ]
      };
    },
    methods: {
      toggleAccordion(index) {
        this.openAccordionIndex = this.openAccordionIndex === index ? null : index;
      },
      isOpen(index) {
        return this.openAccordionIndex === index;
      }  

    }
  };
  </script>
    

  <style>
  /* Add custom styles if needed. Tailwind CSS handles most of the styling here. */
  </style>
   